import { useId } from "react"
import { Tooltip as ReactTooltip } from "react-tooltip"
import { InformationCircleIcon } from "@heroicons/react/24/solid"
import { cn } from "toptaal-shared"

interface TooltipProps {
  children: string
  buttonClassName?: string
}

export function Tooltip({ children, buttonClassName }: TooltipProps) {
  const id = useId()
  const toolTipId = `tooltip-${id}`

  return (
    <>
      <button
        type="button"
        data-tooltip-id={toolTipId}
        className={cn("cursor-help -mt-2", buttonClassName)}
      >
        <InformationCircleIcon className="size-5 fill-primary-blue" />
      </button>

      <ReactTooltip
        id={toolTipId}
        place="top"
        content={children}
        style={{
          backgroundColor: "var(--color-primary-dark-blue)",
          color: "var(--color-white)",
        }}
        opacity={1}
        openOnClick={false}
        delayShow={200}
        openEvents={{ mouseenter: true }}
        closeEvents={{ mouseleave: true }}
      />
    </>
  )
}
